
import { withInstall } from "../../utils/install";
import ATooltip from "./src/main.vue";
ATooltip.name = "ltATooltip";
export const ltATooltip = withInstall(ATooltip);
export default ltATooltip;

